// extracted by mini-css-extract-plugin
export default {"gridContainer":"Grid_gridContainer__BbZ60","noGrid":"Grid_noGrid__drxwd","reviews":"Grid_reviews__9rc3h"};